import { useState, useEffect } from 'react'
import { BreakpointMobile } from '../defines/defines'

export function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(() => window.matchMedia(query).matches)

    useEffect(() => {
        const mql = window.matchMedia(query)
        const listener = (e: MediaQueryListEvent) => setMatches(e.matches)
        mql.addEventListener('change', listener)
        setMatches(mql.matches)
        return () => mql.removeEventListener('change', listener)
    }, [query])

    return matches
}

export function useIsMobile(): boolean {
    return useMediaQuery(`(max-width: ${BreakpointMobile}px)`)
}
